import { Loader2 } from 'lucide-react';

import { type EmailToggle } from '~entities/settings/email-settings/api/get-email-toggles';

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';
import { Switch } from '~shared/shadcn/ui/switch';

interface EmailTogglesAllToggleProps {
  toggles: Array<EmailToggle>;
  isPending?: boolean;
  onToggle: (checked: boolean) => void | Promise<void>;
}

export const EmailTogglesAllToggle = ({
  toggles,
  isPending = false,
  onToggle,
}: EmailTogglesAllToggleProps) => {
  const allEnabled =
    toggles.length > 0 && toggles.every((toggle) => !toggle.disabled);

  return (
    <Card className='w-full'>
      <CardHeader className='pb-2'>
        <div className='flex items-center justify-between gap-2'>
          <div className='min-w-0'>
            <CardTitle className='text-lg'>All email notifications</CardTitle>
            <CardDescription>
              Enable or disable every email scenario at once
            </CardDescription>
          </div>
          <div className='relative flex shrink-0 items-center'>
            {isPending && (
              <div className='absolute -left-7 top-1 flex items-center'>
                <Loader2 className='size-4 animate-spin' />
              </div>
            )}
            <Switch
              checked={allEnabled}
              onCheckedChange={onToggle}
              disabled={isPending || toggles.length === 0}
              aria-label='Toggle all email notifications'
            />
          </div>
        </div>
      </CardHeader>
    </Card>
  );
};
